<script lang="ts" setup>
// -----------------------
// props & emits
// -----------------------
const props = defineProps({
  width: {
    type: Number,
    default: () => 30,
  },
  height: {
    type: Number,
    default: () => 30,
  },
  color: {
    type: String,
    required: true,
  },
  palette: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  selected: {
    type: Boolean,
    default: () => false,
  },
});

// -----------------------
// computed properties
// -----------------------
const computedClasses = computed(() => {
  const classes: string[] = ["bg-palette-" + props.palette];

  if (props.selected) {
    classes.push("outline", "outline-1", "outline-offset-2", "shadow-md");
  }

  if (props.disabled) {
    classes.push("disabled");
    classes.push("opacity-30");
  }

  return classes.join(" ");
});
</script>

<template>
  <button
    class="relative rounded-full"
    :class="computedClasses"
    :title="color"
    :style="{ width: width + 'px', height: height + 'px' }"
  ></button>
</template>
<style scoped>
button::after {
  content: "";
  display: block;
  position: absolute;
  height: 100%;
  left: calc(50% - 1px);
  bottom: 0;
  width: 2px;
  background-color: transparent;
  transform: rotate(45deg);
}

button.disabled::after {
  background-color: #f7f7f7;
}
</style>
